<template>

  <div style="min-height: 40px;">
    <div v-show="showContent">
      <div class="d-flex align-center justify-center">
        <v-btn icon="mdi-arrow-left" size="x-small" variant="text" @click="decDate()">
        </v-btn>

        <v-menu v-model="dateMenu" transition="scale-transition" :close-on-content-click="false">
          <template v-slot:activator="{ props }">
            <span v-bind="props" class="cursor-pointer">{{ dayStr }}</span>
          </template>
          <v-locale-provider locale="ru">
            <v-date-picker hide-header bg-color="grey-lighten-5" :max="semesterSettings ? semesterSettings.end : null"
              :min="semesterSettings ? semesterSettings.begin : null" v-model="selectedDate" no-title
              @update:modelValue="dateMenu = false"></v-date-picker>
          </v-locale-provider>
        </v-menu>

        <v-btn icon="mdi-arrow-right" size="x-small" variant="text" @click="incDate()">
        </v-btn>
      </div>
      <div v-show="load && showContent">
        <v-skeleton-loader type="article"></v-skeleton-loader>
      </div>
      <v-row v-show="!load || !showContent" justify="center">
        <v-col class="py-6 d-flex align-center justify-center" v-for="(ttRecordLesson, index) in tt" :key="index">
          <v-card color="amber-lighten-5" width="230" style="height: 100%">
            <v-card-text>
              <v-row>
                <v-col cols="8">
                  <v-avatar color="blue-lighten-4">{{
                    ttRecordLesson[0]["lesson"]
                    }}</v-avatar>
                </v-col>
                <v-col class="d-flex align-center justify-center">
                  <div>
                    {{ ttRecordLesson[0]["lesson_start"] }}
                    <v-divider style="margin: 0" class="border-opacity-100"></v-divider>
                    {{ ttRecordLesson[0]["lesson_end"] }}
                  </div>
                </v-col>
              </v-row>
              <v-row v-for="(ttRecord, i) in ttRecordLesson" :key="i"
                :class="ttRecord.cancel == 1 ? 'bg-red-lighten-4' : ''">
                <v-col cols="12" class="d-flex align-center justify-center">
                  <a v-if="ttRecord.cid" :href="$model.wwwroot + '/course/view.php?id=' + ttRecord.cid" target="_blank">{{
                    ttRecord.discipline
                    }}</a>
                  <span v-else>{{ttRecord.discipline}}</span>
                  <span v-if="ttRecord.cancel == 1">(Отмена)</span>
                </v-col>

                <v-col>
                  <span style="color: red;text-decoration: line-through;" v-if="ttRecord.changedTeacher">{{
                    ttRecord.changedTeacher }}</span>
                  {{ ttRecord.lastname }}
                </v-col>
                <v-col>
                  {{ ttRecord.classroom }}
                </v-col>
                <v-divider v-if="i != ttRecordLesson.length - 1" style="margin: 0"
                  class="border-opacity-100"></v-divider>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div v-if="$model.isTeacher" class="text-center">
            <a target="_blank"
              :href="$model.wwwroot + '/blocks/manage_groups/timetable_new/print_tt_teacher.php?prep_id=' + $model.userid">
              Расписание на неделю
            </a>
          </div>
          <div v-if="$model.group" class="text-center">
            <a target="_blank"
              :href="$model.wwwroot + '/blocks/manage_groups/website/view.php?gr=' + $model.group.id + '&dep=' + $model.group.department_id">
              Расписание на неделю
            </a>
          </div>
        </v-col>
      </v-row>
    </div>
    <div v-if="!showContent" class="cursor-pointer">
      <v-col class="d-flex flex-column align-center">
        <v-icon color="info" icon="mdi-calendar-month"></v-icon>
      </v-col>

      <v-col style="word-break: break-all" class="d-flex flex-column align-center">
        <span>Расписание</span>
      </v-col>
    </div>
  </div>
</template>

<script>
import { useDate } from "vuetify";
export default {
  props: {
    //поле data из psm_desktop_widgets
    data: {
      required: true,
    },
    showContent: {
      default: false,
      type: Boolean
    }
  },
  name: "timetableWidget",
  data() {
    return {
      tt: [],
      day: 0,
      dayStr: "",
      load: false,
      dateMenu: false,
      selectedDate: null,
      dateFormatter: false,
      semesterSettings: null,
      getDayTTControl: []
    };
  },
  watch: {
    day: function (newVal, oldVal) {
      this.loadTT();
    },
    selectedDate: function (newVal, oldVal) {
      this.day = new Date(newVal);
    },
    showContent: function (newVal) {
      if (newVal && this.semesterSettings === null) {
        this.loadData();
      }
    }
  },
  created() {
    if (!this.showContent) {
      return
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/psm_desktop2/widgets/timetable/getSemesterDates"
        )
        .then((response) => {
          this.semesterSettings = response.data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.day = new Date();
      this.dateFormatter = useDate();
    },
    incDate() {
      this.day.setDate(this.day.getDate() + 1)
      this.day = new Date(this.day)
    },
    decDate() {
      this.day.setDate(this.day.getDate() - 1)
      this.day = new Date(this.day)
    },
    loadTT() {
      //быстро кликаем запрос расписания, до того как ответ придет
      //интересен ответ только на последний запрос, остальные можно прервать
      let AbortControl;
      while (AbortControl = this.getDayTTControl.pop()) {
        AbortControl.abort();
      }
      AbortControl = new AbortController();
      this.getDayTTControl.push(AbortControl);
      //----------------------------------------------------

      this.load = true;
      let options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };

      this.dayStr = this.day.toLocaleDateString("ru-RU", options);
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/psm_desktop2/widgets/timetable/getTimetable",
          new URLSearchParams({
            dayStr: this.day.toLocaleDateString("en-US"),
          }),
          {
            signal: AbortControl.signal,
          }
        )
        .then((response) => {
          if (typeof response.data == "object") {
            this.tt = response.data;
          }

          this.load = false;
        })
        .catch((error) => {
          if (error.code != "ERR_CANCELED") {
            console.log(error);
            this.load = false;
          }
        });
    },
  },
};
</script>
<style lang="scss">
/*
#procollege_desktop2 {
  .pointer {
    cursor: pointer;
  }
}
*/
</style>
